import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { SET_ACTIVE_TAB } from "../../redux/actions/main";
import PollsTable from "./fragments/Table";

const PollsAdmin = () => {
    const [t, i18n] = useTranslation('global');
    const prefix = 'polls.data';
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: SET_ACTIVE_TAB, tab: '/polls' });
    }, []);

    return (
        <PollsTable
            is_admin
            theaders={[
                '#',
                t(`${prefix}.name`),
                t(`${prefix}.to`),
                t(`${prefix}.status`),
                t(`${prefix}.created-at`),
                t(`${prefix}.actions`)
            ]}
            tkeys={['id', 'name', 'to', 'status', 'created_at']}
            tbadges={[{ index: 3, color: 'status_color' }]}
            params={{}}
        />
    );
}

export default PollsAdmin;